import React, { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet-async'

import { DEFAULT_OG_IMAGE } from '../../../utils'

type HeadProps = {
  title: string
  description: string
}

/**
 * react-helmet-async adds meta by default.
 * Add the attribute data-rh to each meta attribute in index.html for override.
 * If we do not update a meta with a data-rh attribute,
 * that meta will be deleted, so make all props required.
 *
 * index.html の静的 `og:image` / `twitter:image` には `data-rh` を付けて
 * helmet 管理下に置いている。このため施設画像を出さないページでは helmet が
 * デフォルト画像を保てるよう、Head 自身が常にデフォルト OGP 画像を1つ出す
 * （`PropertySeoHead` / `PropertyDetailHead` は施設画像で上書きする）。
 */
export const Head: React.FC<PropsWithChildren<HeadProps>> = ({
  title,
  description,
  children,
}) => (
  <React.Fragment>
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
    </Helmet>
    {children}
  </React.Fragment>
)
